module.exports = __webpack_public_path__ + "static/miljo2-5091eee6b176a7aa2f3822a01db50422.jpg";